import { Button, FormGroup, Grid, TextField } from "@mui/material";
import WindowPattern from "../../../../Components/Patterns/Window";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function AddEmployeePlea () {

    return (
        <WindowPattern path="V.I | Pleito - Orçamento - Cronograma Financeiro - Novo Funcionário">

            <FormGroup style={{ height: '540px', justifyContent: 'center', display: 'flex', margin: '0px 50px' }}>

                <Grid container spacing={2}>

                    <Grid item md={12}>
                        <TextField
                            fullWidth
                            required
                            label="Exemplo de datas requeridas"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            required
                            label="Matricula"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            required
                            label="Salário"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            required
                            label="Cargo"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            required
                            label="Valor Mensal Bruto"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={6}>
                        <TextField
                            fullWidth
                            label="Escolaridade"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={6}>
                        <TextField
                            fullWidth
                            required
                            label="Área de Formação"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            label="Beneficios"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            label="Encargos"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            label="Atividade no Projeto"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker sx={{ width: '100%', background: 'var(--color-white)' }} label="Data de Admissão" />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Alocação no Projeto (%)"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Meses de Trabalho Realizado"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Valor Mensal Financeiro"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker sx={{
                                width: '100%',
                                '& .MuiDateCalendar-root': {
                                    background: 'white'
                                }
                            }} label="Data de Admissão" />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Meses trabalhados (Ano Base)"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Valor já Realizado"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Financiamento (Ano Base X)"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <Grid item md={2.4}>
                        <TextField
                            fullWidth
                            required
                            label="Meses de Trabalho (Ano X + 1)"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            required
                            label="Financiamento (Ano X + 1)"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            required
                            label="Meses de Trabalho (Ano X + 2)"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <Grid item md={3}>
                        <TextField
                            fullWidth
                            required
                            label="Financiamento (Ano X + 2)"
                            placeholder="Digite Aqui..."
                        />
                    </Grid>

                    <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                        <Button variant="contained" style={{ background: 'var(--color-blue)' }}>Cadastro Novo Funcionário</Button>
                    </div>

                </Grid>

            </FormGroup>

        </WindowPattern>
    )
}